var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _path6, _rect5, _rect6, _rect7, _rect8, _path7, _path8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLibertyDeprivation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 44C3 41.7909 4.79086 40 7 40H95C97.2091 40 99 41.7909 99 44V60H3V44Z",
    fill: "#D6E8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3636 25H85.6364L99 42H1L14.3636 25Z",
    fill: "#B0D2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 38C1.5 29.9919 7.99187 23.5 16 23.5H84C92.0081 23.5 98.5 29.9919 98.5 38V59.5H1.5V38Z",
    stroke: "#D7AE88",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C13.5 13.3056 17.3056 9.5 22 9.5H78C82.6944 9.5 86.5 13.3056 86.5 18V23.5H13.5V18Z",
    stroke: "#D7AE88",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 39C6 32.9249 10.9249 28 17 28H83C89.0751 28 94 32.9249 94 39V61H6V39Z",
    fill: "#EFD1B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 49,
    width: 6,
    height: 3,
    fill: "#D7AE88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 49,
    width: 6,
    height: 3,
    fill: "#D7AE88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 6,
    height: 3,
    fill: "#D7AE88"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 40,
    width: 6,
    height: 3,
    fill: "#D7AE88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C22 1.79086 23.7909 0 26 0H74C76.2091 0 78 1.79086 78 4V22H22V4Z",
    fill: "#D6E8F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 61,
    width: 6,
    height: 7,
    fill: "#D7AE88"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 61,
    width: 6,
    height: 7,
    fill: "#D7AE88"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 19,
    width: 22,
    height: 27,
    rx: 1,
    fill: "#2974B2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 21,
    width: 18,
    height: 23,
    rx: 0.5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2922 26C76.8538 26 76.4541 26.1667 76.1518 26.4405C76.0677 26.5168 75.9325 26.5168 75.8484 26.4405C75.5461 26.1666 75.1464 26 74.708 26C73.7648 26 73 26.7714 73 27.7231C73 28.5547 73.8039 29.9676 75.5843 30.8327C75.6926 30.8852 75.8045 30.9358 75.9199 30.984C75.9708 31.0053 76.0294 31.0053 76.0803 30.984C76.1958 30.9358 76.3076 30.8852 76.4158 30.8327C78.1961 29.9676 79 28.5547 79 27.7231C79 26.7714 78.2354 26 77.2922 26Z",
    fill: "#E23E5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4741 30.0713C66.6151 29.9625 66.8213 29.9801 66.9397 30.1112L70.2172 33.7398L71.8736 32.718C72.0096 32.6341 72.189 32.6548 72.3002 32.7671L75.7821 36.2877L77.1073 35.295C77.2385 35.1968 77.4254 35.2053 77.5462 35.3149L79.8958 37.4483C80.0301 37.5702 80.0353 37.7727 79.9074 37.9007C79.7796 38.0287 79.5671 38.0336 79.4328 37.9117L77.2936 35.9694L75.9556 36.9716C75.8191 37.0739 75.6232 37.06 75.504 36.9395L72.0035 33.4001L70.3362 34.4287C70.1954 34.5155 70.0089 34.49 69.8995 34.3688L66.6434 30.764L64.5469 32.3821C64.4028 32.4933 64.1914 32.472 64.0748 32.3347C63.9581 32.1973 63.9804 31.9958 64.1245 31.8846L66.4741 30.0713Z",
    fill: "#093E62",
    stroke: "#093E62",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 18,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#2974B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLibertyDeprivation);
export default __webpack_public_path__ + "static/media/imgLibertyDeprivation.d32ee8ee1077bcec91a28f5868913303.svg";
export { ForwardRef as ReactComponent };